jQuery(document).ready(function(){
  $(".menu_div").click(function(){
    $(".toplmenu").hide();
    $(".toplmenu1").show();
    $(".mobilemenu").css('left','0px');
    $(".mobilemenu").fadeIn(500);
  });
  $(".menu_icn").click(function(){
    $(".toplmenu").show();
    $(".toplmenu1").hide();
    $(".mobilemenu").fadeOut(600);
  });
});



/*
function reset_acc() {
  $('.ac-title').removeClass('acc-active');
  $('.accordian-para').slideUp();
  $('.plus-icon').removeClass('cross-icon');
}

$('.ac-title').click(function (e) {
  e.preventDefault();
  if ($(this).hasClass('acc-active'))
  {
    reset_acc();
  }
  else {
    reset_acc();
    var getID = $(this).attr('data-in');
    $(getID).slideDown();
    $(this).addClass('acc-active');
    $(this).find('.plus-icon').addClass('cross-icon');
  }
});
*/

$(".testimonial_selider_inner").slick({
  dots: true,
  infinite: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(document).ready(function(){
  $('.scrollTo').click(function(){
    $('html, body').animate({
      scrollTop: $( $(this).attr('href') ).offset().top
    }, 500);
    return false;
  });

});